import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { TranslationService } from './modules/i18n';
import { locale as enLang } from './modules/i18n/vocabs/en';
import { locale as chLang } from './modules/i18n/vocabs/ch';
import { locale as esLang } from './modules/i18n/vocabs/es';
import { locale as jpLang } from './modules/i18n/vocabs/jp';
import { locale as deLang } from './modules/i18n/vocabs/de';
import { locale as frLang } from './modules/i18n/vocabs/fr';
import { Meta } from '@angular/platform-browser';

@Component({
  standalone: false,
  selector: 'body[root]',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  constructor(
    private translationService: TranslationService,
    private meta: Meta,
  ) {
    this.translationService.loadTranslations(enLang, chLang, esLang, jpLang, deLang, frLang);
  }

  ngOnInit() {
    this.meta.addTags([
      {
        name: 'description',
        content:
          'Risk Release RiskRelease Renters Insurance Rental Waiver Program Renters Compliance Renters Legal Liability Compliant Rent Apartment Insurance Insurance Lease Requirement Lease Insurance Requirements Rental Insurance Requirement',
      },
      {
        name: 'keywords',
        content:
          'Risk Release,RiskRelease,riskrelease,Renters Insurance,Rental Waiver Program,Renters Compliance,Renters Legal Liability,Compliant Rent,Apartment Insurance,Insurance Lease Requirement,Lease Insurance Requirements,Rental Insurance Requirement,angular, javascript, typescript, meta, seo',
      },
    ]);
    setTimeout(() => {
      this.meta.updateTag({
        name: 'keywords',
        content:
          'Risk Release,RiskRelease,riskrelease,Renters Insurance,Rental Waiver Program,Renters Compliance,Renters Legal Liability,Compliant Rent,Apartment Insurance,Insurance Lease Requirement,Lease Insurance Requirements,Rental Insurance Requirement,angular, javascript, typescript, meta, seo',
      });
    }, 2000);
  }
}
